// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wj_a bhy_b bhy_we"};